// mission-initializer-errors.ts
//
// Tách THUẦN từ mission-initializer.ts (phase 10, lô A): error class dùng chung
// bởi mission-initializer.ts và mission-initializer-request.ts (leaf, không phụ
// thuộc gì khác — tránh vòng import).

export class InitValidationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "InitValidationError";
  }
}
